module.exports = __webpack_public_path__ + "static/logo-e8c72b9965e6bb9a8e52667349fb105e.svg";